import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useData } from '../../hooks/DataProvider';

import { Menu as MainMenu } from '../../components/Menu';
import { ModelTier } from '../../models/ModelTier';
import { CreatFieldComponent } from '../../components/Fields';

import { generateId, ganerateCodeTier } from '../../scripts/utils';

import { Box, Button, Typography } from '@mui/material';

import { getTiers, updateTier, deleteTier } from '../../api/tiers';

import Contact from './Contact'; // Assuming Contact is a component for managing contacts

import translations from '../../scripts/translations';

const Tier = () => {

    const { tierId } = useParams();
    const { dataTier, updateDataTier, language } = useData();
    const screenSizeIsSmall = useMediaQuery('(min-width:600px)');
    const navigate = useNavigate();

    const btns = translations.button[language];
    const page = translations.pages.tier[language];

    const [dataContact, setDataContact] = useState({});

    const handelSave = async () => {

        if (!dataTier.code) {
            const code = await ganerateCodeTier(dataTier);
            dataTier.code = code;
        }

        console.log(dataTier);

        if (dataTier._id && dataTier._id !== 'new') {

            updateTier(dataTier).then(rs => {
                if (rs) {
                    updateDataTier(rs);
                    console.log('Tier updated successfully:', rs);
                }
            });
        }
    }


    const handelNew = () => {
        updateDataTier({
            _id: generateId(),
            code: '',
            name: '',
            isClient: false,
            isFournisseur: false,
            isSubcontractor: false,
            isCarrier: false,
            address: '',
            address2: '',
            zipCode: '',
            city: '',
            countryCode: '',
            country: '',
            siret: '',
            tva: '',
            memo: '',
            contacts: [],
        })
    }

    const handeDelete = () => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce Tier ?') && dataTier._id && dataTier._id !== 'new') {
            deleteTier(dataTier._id).then(rs => {
                if (rs) {
                    console.log('Tier deleted successfully:', rs);
                    updateDataTier({})
                    navigate('/tiers');
                }
            });
        }
    }

    useEffect(() => {
        if (tierId === 'new') {
            handelNew();
        } else if (tierId && tierId !== 'new') {

            getTiers({ _id: tierId }).then(rs => {
                if (rs && rs.length > 0) {
                    updateDataTier(rs[0]);
                } else {
                    console.log('Tier not found or no data returned');
                    updateDataTier({});
                }
            });
        }
    }, [tierId]);




    return (
        <>
            <MainMenu currentPage={'tiers'} />

            <Box sx={{ mb: 2, py: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {/* <h2>Tiers: {tierId}</h2> */}
                <Box></Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant='outlined' onClick={handelSave}>{btns.save}</Button>
                    <Button variant='outlined' onClick={() => { navigate('/tiers/new') }}>{btns.add}</Button>
                    <Button variant='outlined' onClick={handeDelete} disabled={tierId === 'new' ? true : false} color="secondary" >{btns.delete}</Button>
                    {/* <Button variant='outlined' onClick={() => { navigate('/tiers') }}>Lest des tiers</Button> */}
                    <Button variant='outlined' onClick={() => console.log(dataTier)}>{btns.print}</Button>
                    {/* <Button variant='outlined' onClick={test}>Test</Button> */}
                </Box>
            </Box>



            <Box sx={{ display: 'flex', gap: 2, flexDirection: screenSizeIsSmall ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'flex-start' }}>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, my: 2, width: screenSizeIsSmall ? '400px' : '100%' }}>

                    <CreatFieldComponent field={ModelTier.code} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.name} data={dataTier} updateData={updateDataTier} />

                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <CreatFieldComponent field={ModelTier.isClient} data={dataTier} updateData={updateDataTier} />
                        <CreatFieldComponent field={ModelTier.isFournisseur} data={dataTier} updateData={updateDataTier} />

                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <CreatFieldComponent field={ModelTier.isSubcontractor} data={dataTier} updateData={updateDataTier} />
                        <CreatFieldComponent field={ModelTier.isCarrier} data={dataTier} updateData={updateDataTier} />

                    </Box>

                    <CreatFieldComponent field={ModelTier.address} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.address2} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.zipCode} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.city} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.countryCode} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.country} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.siret} data={dataTier} updateData={updateDataTier} />
                    <CreatFieldComponent field={ModelTier.tva} data={dataTier} updateData={updateDataTier} />

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        <Typography variant='overline'>{page.memo}</Typography>
                        <CreatFieldComponent field={ModelTier.memo} data={dataTier} updateData={updateDataTier} />
                    </Box>


                </Box>
                <Box sx={{ width: screenSizeIsSmall ? '400px' : '100%' }}>
                    <Typography variant='overline' > {page.associatedContact}</Typography>
                    <Contact dataTier={dataTier} updateDataTier={updateDataTier} dataContact={dataContact} setDataContact={setDataContact} />

                </Box>
            </Box>
        </>
    );
}

export default Tier;
